import * as Scrivito from 'scrivito';

import { getInstanceIdFromPath } from './getInstanceIdFromPath';

// @ts-expect-error: ignore nonexistent property
window.Scrivito = Scrivito;

const BOT_CONFIG_SITE_ID = 'bot_config';

export function configureScrivito() {
  const tenant = getInstanceIdFromPath();
  if (!tenant) return;

  Scrivito.configure({
    tenant,

    // TODO would be nice to have a more declarative way to express this
    baseUrlForSite: (siteId) => {
      if (siteId === null || siteId === BOT_CONFIG_SITE_ID) {
        return `${window.location.origin}/${getInstanceIdFromPath()}`;
      }
    },

    siteForUrl: (url) => {
      const origin = new URL(url).origin;
      if (origin !== window.location.origin) return;

      return {
        siteId: BOT_CONFIG_SITE_ID,
        baseUrl: `${origin}/${getInstanceIdFromPath()}`,
      };
    },
  });
}
